/** Team-scoped User column filters for consultant portal list pages. */

export const CONSULTANT_TEAM_SEARCH_ENABLED =
  process.env.REACT_APP_DEBIT_NOTE_SEARCH_TEAM === "true";

/** Back-office and consultant handlers; excludes channel users. */
export const HANDLER_FILTER_USER_PRE_QUERY = {
  status: "ACTIVE",
  userType: { $in: ["BACKOFFICE", "CONSULTANT"] },
};

/** Sentinel for column filters that support unset/null values. */
export const FILTER_EMPTY_VALUE = null;

export const FILTER_EMPTY_OPTION = {
  label: "-- Empty --",
  value: FILTER_EMPTY_VALUE,
};

export function isConsultantPortalRole(role) {
  return role === "CONSULTANT" || role === "CHANNEL";
}

export async function getTeamUserIds(auth, api) {
  const selfId = auth().id;
  const downline = await api.User.getAllTeamMembers(selfId);
  return [selfId, ...downline];
}

export function formatTeamUserLabel(user) {
  const staffId = user.staffId ?? " -- ";
  const alias = user.aliasName ? `,${user.aliasName}` : "";
  const cname = user.cname ? ` ${user.cname}` : "";
  return `[${staffId}] ${user.name ?? ""}${alias}${cname}`.trim();
}

export function buildTeamUserFilterOptions(users, labelField = "name") {
  return (users ?? []).map((user) => ({
    label: formatTeamUserLabel(user) || user[labelField] || String(user._id),
    value: user._id,
  }));
}

/**
 * Tags matching column filters with teamUserIds so DataTable loads roster options.
 * @param {Array} columns - tableSchema.columns
 * @param {string[]} teamUserIds
 * @param {string[]} fields - filter.field names (e.g. consultants, signedBy)
 */
export function applyTeamUserFilters(columns, teamUserIds, fields = ["consultants"]) {
  if (!columns?.length || !teamUserIds?.length) return;

  columns.forEach((col) => {
    const field = col.filter?.field;
    if (
      !col.filterable ||
      !field ||
      !fields.includes(field) ||
      col.filter?.populate?.model !== "User"
    ) {
      return;
    }
    col.filter.teamUserIds = teamUserIds;
    col.filter.scope = "team";
  });
}
